import React from "react"
import { IScheduleShift, IScheduleDailyTimelineData } from "../../models"
import TimelineTable from "./daily_timeline/TimelineTable"
import AccountStore from "../../stores/AccountStore"
import * as utils from "../../helpers/utils"
import * as timeHelper from "../../helpers/timeHelper"
import * as scheduleHelper from "../../helpers/scheduleHelper"

interface IProps {
  shiftTemplates: IScheduleShift[]
  totalWidth: number
}

const DayTimelineBar: React.SFC<IProps> = (props: IProps) => {
  const timelineData: IScheduleDailyTimelineData[][] = new Array(1)
  const dailyTimelineData: IScheduleDailyTimelineData[] = []
  props.shiftTemplates.forEach(shiftTemplate => {
    dailyTimelineData.push(scheduleHelper.getTimelineTableDataFromShift(shiftTemplate, undefined))
  })
  
  timelineData[0] = dailyTimelineData
  const getIimelineItemRenderElement = (timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number) => {
    const timelineItemData = props.shiftTemplates[orderNumber]
    const position = AccountStore.getCurrentAccount().PositionDefinitions.find((item) => item.Id === timelineItemData.PositionId)
    const backgroundColor = position && position.Color ? position.Color : AccountStore.getPositionDefaultColor()
    return (
      <div style={{ backgroundColor, height: 46, textAlign: "center", display: "flex" }}>
        <div style={{ flex: 0.2 }} />
        <div style={{ color: "white", flex: 1, paddingTop: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {`${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.StartTime)}-${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.EndTime)}`}
        </div>
        <div style={{ flex: 0.1 }} />
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            height: 30,
            marginTop: 8,
            fontSize: 15,
            borderRadius: 15,
            backgroundColor: utils.getMaterial900ColorFrom500Color(backgroundColor),
            color: "rgba(254, 254, 254, 0.5)",
          }}
        >
          <div style={{ marginTop: 5 }}>
            {timelineItemData.Name}
          </div>
        </div>
        <div style={{ flex: 0.2 }} />
      </div>
    )
  }

  return (
    <TimelineTable
      items={props.shiftTemplates}
      timelineData={timelineData}
      timelineItemRenderElement={getIimelineItemRenderElement}
      leftSideColumns={[]}
      multiSelectable={false}
      selectable={false}
      readonly={true}
      timelineTableWidth={props.totalWidth}
      dontNeedLeftSideTable={true}
    />
  )
}

export default DayTimelineBar
